module.exports = __webpack_public_path__ + "img/3@2x (2).48f52bfc.png";